import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LazyImage from '../../components/ui/LazyImage/LazyImage';
import './Loyalty.css'; // S'assurer que les styles nécessaires sont dans Loyalty.css

export const SortableLoyaltyCard = ({ item, viewMode, onEdit, onDelete, isDeleting, itemToDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`loyalty-card ${viewMode} ${isDragging ? 'dragging' : ''}`}
    >
      {/* Badge pour l'ordre */}
      {typeof item.order !== 'undefined' && (
        <div className="order-badge"> {/* Cette classe doit être définie dans Loyalty.css ou globalement */}
          {item.order}
        </div>
      )}
      <div className="loyalty-image">
        <LazyImage 
          src={item.imageUrl} 
          alt={item.titre} 
        />
      </div>
      <div className="loyalty-content">
        <h3>{item.titre}</h3>
        <p>{item.description}</p>
        {/* Si les avantages ont une catégorie ou un champ similaire, ajoutez-le ici */}
      </div>
      <div className="loyalty-actions">
        <button 
          className="edit-btn"
          onClick={(event) => {
            event.stopPropagation();
            onEdit(item);
          }}
        >
          Modifier
        </button>
        <button 
          className="delete-btn"
          onClick={(event) => {
            event.stopPropagation();
            onDelete(item);
          }}
          disabled={isDeleting}
        >
          {isDeleting && itemToDelete?.id === item.id ? 'Suppression...' : 'Supprimer'}
        </button>
      </div>
    </div>
  );
}; 